import axios from "axios";
import apis from ".";

export const getLatLngApi = async (zipcode) => {
    // const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
    try {
        const response = await axios.get(`${apis.getLatLng.latlng}=${zipcode}&country=IN&format=json`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return response;
    } catch (error) {
        console.error("Error creating facility:", error);
        throw error;
    }
};